import dayjs from 'dayjs';

// Utility functions for leave management

export const getInitialLeaveFormData = () => ({
  employee: '',
  leave_type: '',
  start_date: null,
  end_date: null,
  reason: '',
  status: 'Pending',
});

export const getInitialLeaveSettingsFormData = () => ({
  employee: '',
  sick_leaves_per_annum: '',
  casual_leaves_per_annum: '',
  earned_leaves_per_annum: '',
  maternity_leaves_per_annum: '',
  paternity_leaves_per_annum: '',
  unpaid_leaves_per_annum: '',
  other_leaves_per_annum: '',
});

export const formatLeaveDataForSubmission = (formData) => ({
  employee_id: formData.employee,
  leave_type: formData.leave_type,
  start_date: formData.start_date ? formData.start_date.format('YYYY-MM-DD') : null,
  end_date: formData.end_date ? formData.end_date.format('YYYY-MM-DD') : null,
  reason: formData.reason,
  status: formData.status,
});

export const formatLeaveSettingsDataForSubmission = (formData) => ({
  employee_id: formData.employee,
  sick_leaves_per_annum: formData.sick_leaves_per_annum === '' ? 0 : formData.sick_leaves_per_annum,
  casual_leaves_per_annum: formData.casual_leaves_per_annum === '' ? 0 : formData.casual_leaves_per_annum,
  earned_leaves_per_annum: formData.earned_leaves_per_annum === '' ? 0 : formData.earned_leaves_per_annum,
  maternity_leaves_per_annum: formData.maternity_leaves_per_annum === '' ? 0 : formData.maternity_leaves_per_annum,
  paternity_leaves_per_annum: formData.paternity_leaves_per_annum === '' ? 0 : formData.paternity_leaves_per_annum,
  unpaid_leaves_per_annum: formData.unpaid_leaves_per_annum === '' ? 0 : formData.unpaid_leaves_per_annum,
  other_leaves_per_annum: formData.other_leaves_per_annum === '' ? 0 : formData.other_leaves_per_annum,
});

export const getLeaveFormDataFromRecord = (leave) => ({
  employee: leave.employee.id,
  leave_type: leave.leave_type,
  start_date: leave.start_date ? dayjs(leave.start_date) : null,
  end_date: leave.end_date ? dayjs(leave.end_date) : null,
  reason: leave.reason || '',
  status: leave.status,
});

export const getLeaveSettingsFormDataFromRecord = (settings) => ({
  employee: settings.employee.id,
  sick_leaves_per_annum: settings.sick_leaves_per_annum,
  casual_leaves_per_annum: settings.casual_leaves_per_annum,
  earned_leaves_per_annum: settings.earned_leaves_per_annum,
  maternity_leaves_per_annum: settings.maternity_leaves_per_annum,
  paternity_leaves_per_annum: settings.paternity_leaves_per_annum,
  unpaid_leaves_per_annum: settings.unpaid_leaves_per_annum,
  other_leaves_per_annum: settings.other_leaves_per_annum,
});

export const calculateLeaveDays = (startDate, endDate) => {
  if (!startDate || !endDate) return 0;
  const start = dayjs(startDate);
  const end = dayjs(endDate);
  return end.diff(start, 'day') + 1;
};

export const getStatusColor = (status) => {
  switch (status) {
    case 'Approved':
      return 'success';
    case 'Rejected':
      return 'error';
    case 'Pending':
      return 'warning';
    default:
      return 'default';
  }
};
